var UrlUtils = /** @class */ (function () {
    function UrlUtils() {
    }
    UrlUtils.getUrlParam = function (item) {
        var allParams = this.getAllUrlParams();
        return allParams[item] || undefined;
    };
    UrlUtils.getAllUrlParams = function () {
        if (this.allParams) {
            return this.allParams;
        }
        var search = location.search.slice(1).split("&");
        var result = {};
        for (var _i = 0, search_1 = search; _i < search_1.length; _i++) {
            var item = search_1[_i];
            var separatorPosition = item.indexOf("=");
            var value = separatorPosition > -1 ? decodeURIComponent(item.slice(separatorPosition + 1)) : "";
            if (value) {
                result[item.slice(0, separatorPosition)] = value;
            }
        }
        this.allParams = result;
        return result;
    };
    return UrlUtils;
}());
export { UrlUtils };
